export default {
  defultnotData: '暂无数据',
  filternotData: '当前筛选条件下没有数据',
  backtitle: '返回',
  modal: {
    okText: '确定',
    cancelText: '取消',
    okTextSave: '保存',
    cancelTaxtClose: '关闭'
  }
}
